// スムーススクロール
(function ($) {
  $('a[href^="#"]:not([class*="ez-toc"]), a[href^="/#"]').on('click', function () {
    if ($(this).hasClass('trigger-menu')) {
      return false;
    } else {
      var scrollSpeed = 300; // → スクロールのスピード
      var headerHeight = $('#l-header').outerHeight();
      // アンカーの値取得
      var href = $(this).attr("href");
      var hrefIndex = href.search('/') + 1;
      // 移動先を取得
      href = href.substr(hrefIndex);
      var target = $(href === "/" || href === "" ? 'html' : href);
      // 移動先を数値で取得
      var position = target.offset().top - headerHeight; // 固定ヘッダの高さ分位置をずらす;
      // スムーススクロール
      $('body,html').animate({ scrollTop: position }, scrollSpeed, 'swing');
      return false;
    }
  });
}(jQuery));
